import { useEffect, useRef, useState } from 'react';
import { Trash2 } from 'lucide-react';
import { deleteBucket } from '../api/buckets.js';
import './ForgetButton.css';

/* ============================================================
   「让他忘掉这条」按钮 —— 记忆星图 / 时间线的详情抽屉共用。
   两步确认：第一次点变红问「真的要忘掉？」，3.5 秒内不点第二次
   就自动收回；第二次点才真的调 DELETE /api/bucket/{id}。
   protected 桶后端会拒（403），错误原样显示。
   ============================================================ */
export default function ForgetButton({ id, onDeleted }) {
  const [phase, setPhase] = useState('idle'); // idle | arm | busy
  const [err, setErr] = useState('');
  const timer = useRef();

  useEffect(() => () => clearTimeout(timer.current), []);
  // 换了一条记忆就复位
  useEffect(() => {
    setPhase('idle');
    setErr('');
  }, [id]);

  const click = async (e) => {
    e.stopPropagation();
    if (phase === 'busy') return;
    if (phase !== 'arm') {
      setPhase('arm');
      setErr('');
      clearTimeout(timer.current);
      timer.current = setTimeout(() => setPhase('idle'), 3500);
      return;
    }
    clearTimeout(timer.current);
    setPhase('busy');
    try {
      await deleteBucket(id);
      onDeleted?.(id);
    } catch (e2) {
      setErr(e2.message || '没删掉，再试一次？');
      setPhase('idle');
    }
  };

  return (
    <div className="fg-wrap">
      <button
        type="button"
        className={'fg-btn' + (phase === 'arm' ? ' arm' : '')}
        onClick={click}
        disabled={phase === 'busy'}
      >
        <Trash2 size={13} strokeWidth={1.6} />
        {phase === 'busy'
          ? '正在忘掉…'
          : phase === 'arm'
            ? '真的要忘掉？再点一次'
            : '让他忘掉这条'}
      </button>
      {err && <div className="fg-err">{err}</div>}
    </div>
  );
}
